import { Link } from "react-router-dom";
import VideoCard from "@/components/feature/VideoCard";
import type { Video } from "@/types/video";
import { sortVideos } from "@/utils/videoFilters";

interface LatestVideosProps {
  videos: Video[];
}

export default function LatestVideos({ videos }: LatestVideosProps) {
  const latest = sortVideos(videos, "latest").slice(0, 8);

  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4">
      {latest.map((video) => (
        <VideoCard key={video.id} video={video} />
      ))}
      <Link
        to="/search"
        className="flex min-h-[180px] cursor-pointer flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-primary-200 bg-primary-50/60 p-5 text-center transition-colors duration-200 hover:bg-primary-100/70"
      >
        <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-50">
          <i className="ri-arrow-right-line text-2xl"></i>
        </span>
        <span className="font-heading text-sm font-semibold text-primary-700">浏览全部视频</span>
        <span className="text-xs text-foreground-500">按分类、标签自由筛选</span>
      </Link>
    </div>
  );
}